import React from "react";
import Typography from '@mui/material/Typography';
import RowStack from '../../components/tabel-component/RowStack';

export default function TopTableHeaderRow({ userDetail }) {
  return (
    <RowStack
      direction="row"
      justifyContent="space-between"
    >
      <Typography variant="body1" gutterBottom>
        SURVEYOR NAME: {userDetail?.userName ?? '-'}
      </Typography>
      <Typography variant="body1" gutterBottom>
        UNIQUE ID: {userDetail?.userEmpId ?? '-'}
      </Typography>
    </RowStack>
  );
};